import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import NavigationLabel from '../../NavigationLabel/NavigationLabel'
import { NAVIGATION_LABELS } from '../../../helpers/constants'

const MarketShopLink = ({ withUpsellingRedirect = false }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/marketShopManagement'
            : '/dashboard/building-dashboard/market-shop'
        }
      >
        <span>
          {t('navbar:upsellingLinks.marketShop')}
          <NavigationLabel type={NAVIGATION_LABELS.HIDDEN} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

MarketShopLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default MarketShopLink
